/* eslint-disable react/no-unescaped-entities */
import RootLayout from '../../../component/Layout';
import TopLogo from '../../../component/TopLogo';
import styles from './style.module.scss';
import { useEffect, useState, useCallback } from 'react';
import useScreenWidthBelowThreshold from '../../../hooks/useScreenWidthBelowThreshold';
import cx from 'classnames';
import ArticleItem from './ArticleItem';
import { List } from 'antd';
import H5Image from 'web-materials/dist/esm/components/common/H5Image';

const comments = [
  {
    content:
      "Looks amazing! I guess even tho it's about finding matches based on shared interests, people can still see others' pictures, right? That might make it not 100% based on interests, but hey, it's going in the right direction! Congrats 🚀",
    name: 'Andrei Costea',
  },
  {
    content:
      'After using Duet for a while I’m glad to see there are genuine people on this APP, not like some others filled with bots🥵It makes me feel safer and more confident in finding a date here💘💘',
    name: 'CarrotWarrior',
  },
  {
    content:
      "I’m obsessed with Duet’s Tags feature. It lets me highlight who I really am and what I care about. I’ve met some incredible people who I resonate with on so many levels. Duet is the best thing that's ever happened to me!",
    name: 'KFJFBFAR',
  },
];

const grid = {
  gutter: 0,
  xs: 2,
  sm: 2,
  md: 2,
  lg: 3,
  xl: 3,
  xxl: 3,
};

const TITLE_PATH =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkNCUDI3Q1MzUUlRVDdaUE5PVkhCNFRRQzRDRUFQQyIsInciOjgwMCwiaCI6MTU2LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MzI5NjgxNjUwODY5OTgxNzQxOCwiYWIiOjB9.png';
const ARROW_PATH =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkxFQTVKWFFMWEFDUEhTT09XWDYyREFIWllTNlFXQiIsInciOjI0LCJoIjoyMiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjY2MDg4NzIzMjc2MTU1MjY3NDcsImFiIjowfQ.png';
const DIVIDER_PATH =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik9GV05WMlVUWlQ0R1pBNzNSNklONjNYQVhWSU5XUSIsInciOjI4ODAsImgiOjIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjowLCJhYiI6MH0.png';
const QUATA_PATH =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkhYWjVUWlIyM0lYUUw1Q0FQVElPRE81VFRFR0RJSyIsInciOjk2LCJoIjo4MCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyODc2NTUwNzU0NDIzNjMyODAzLCJhYiI6MH0.png';
const ACTIVE_SLIDE =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik1MV1dTSkFXV0MzR1RBUEdQSExGNUozNzVJSDJWTCIsInciOjY0MCwiaCI6NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjAsImFiIjowfQ.png';
const Categorys = ['Featured Stories', 'Dating Guide', 'Press', 'Success Stories'];
const Slides = [0, 1, 2];

export default ({ news }) => {
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);
  const [activeCat, setActiveCat] = useState('Featured Stories');
  const { headRes, data } = news || {};
  const curCatArticles = data?.filter((item) => item.category === activeCat) || [];
  const [showAll, setShowAll] = useState(curCatArticles?.length < 6);
  const [width, setWidth] = useState('100%');
  const [startAnim, setStartAnim] = useState(true);
  const [sortedComment, setSortedComment] = useState(comments);
  const sliderWidth = isScreenWidthBelow700px ? 115 : 350;

  const handleClick = useCallback((index) => {
    setActiveCat(Categorys[index]);
  }, []);

  const handleSlideClick = useCallback(
    (idx) => {
      setWidth(`calc(100% - ${idx * sliderWidth}px)`);
      setStartAnim(false);
      setSortedComment([comments[idx], ...comments.slice(idx + 1), ...comments.slice(0, idx)]);
    },
    [sliderWidth]
  );

  useEffect(() => {
    if (!startAnim) setStartAnim(true);
  }, [startAnim]);

  useEffect(() => {
    setShowAll(curCatArticles?.length < 6);
  }, [curCatArticles.length]);

  return (
    <RootLayout className={styles.wrapper}>
      <TopLogo />
      <H5Image type="origin" src={TITLE_PATH} className={styles.title} />
      <div className={styles.subTitle}>
        Need a quote or up-to-date stats? Writing a piece about Duet or dating industry in general?{' '}
        {isScreenWidthBelow700px ? <br /> : ''} We'll be happy to help 📧
        <span className={styles.email}>pr@duetapp.net</span>
      </div>
      <div className={styles.categorys}>
        {Categorys.map((name, index) => {
          return (
            <div
              key={name}
              className={cx(styles.child, { [styles.active]: name === activeCat })}
              onClick={() => handleClick(index)}
            >
              {name}
            </div>
          );
        })}
      </div>
      <ArticleItem {...(headRes?.[0] || [])} isHead />
      <List
        className={styles.article_wrapper}
        grid={grid}
        dataSource={curCatArticles?.slice(0, showAll ? undefined : 6)}
        renderItem={(item) => <ArticleItem key={item.id} {...item} />}
      />
      {!showAll && (
        <div className={styles.readMore} onClick={() => setShowAll(true)}>
          Read More <H5Image type="origin" src={ARROW_PATH} />
        </div>
      )}
      <H5Image type="origin" src={DIVIDER_PATH} className={styles.divider} />
      <div className={styles.commentsWrapper}>
        <div className={cx(styles.comments, { [styles.anim1]: startAnim })}>
          {sortedComment.map((item) => {
            return (
              <div className={styles.comment}>
                <H5Image type="origin" src={QUATA_PATH} className={styles.quata} />
                <div className={styles.commentContent}>{item.content}</div>
                <div className={styles.commentName}>
                  by <span>{item.name}</span>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.slidesWrapper}>
          <div
            className={cx(styles.slider, { [styles.anim]: startAnim })}
            style={{ width: `${width}` }}
            onAnimationIteration={() => setWidth('100%')}
          />
          <div className={styles.spacerWrapper}>
            <div className={styles.spacer1} />
            <div className={cx(styles.spacer1, styles.spacer2)} />
          </div>

          {Slides.map((idx) => (
            <div key={idx} className={styles.slide} onClick={() => handleSlideClick(idx)}>
              <H5Image type="origin" src={ACTIVE_SLIDE} className={styles.slideImg} />
            </div>
          ))}
        </div>
      </div>
    </RootLayout>
  );
};
